import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import Notifications, { notify } from 'react-notify-toast';
import { FORGOTPASSWORDAPI } from '../../../services/Auth/Password.api';
import { Background, Logo, TextLogo } from '../../index';
import Footer from '../../Footer';

function ForgotPassword() {
  const navigate = useNavigate();
  const { register, errors, handleSubmit } = useForm();

  const [email, setEmail] = useState('');
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);

  const forgotPass = async (data, e) => {
    e.preventDefault();

    //Check to see if the email address is present
    if (!email) {
      setError(true);
      return;
    }

    //Check for the email address pattern
    if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      setError(true);
      return;
    }

    const body = { email };
    setLoader(true);
    await FORGOTPASSWORDAPI(body, (err, res) => {
      setLoader(false);
      if (err) {
        let message = err && err.message && !Array.isArray(err.message);
        notify.show(
          message === true ? `Opps! ${err.message} :(` : 'Failed to send link',
          'error',
          3000
        );
      } else if (res && res.data) {
        e.target.reset();
        notify.show(`${res.data.msg}`, 'success', 3000);
      }
    });
  };
  const goToLogin = () => {
    navigate('/');
  };

  return (
    <div className='forgot-password p-4'>
      <div className='row'>
        <div className='container'>
          <div className='pb-3 d-flex justify-content-center align-items-center flex-column'>
            <div className='p-2'>
              <Logo width='100' />
            </div>
            {/* <div className="pt-2 text-center text-logo">
              <TextLogo />
            </div> */}
            <div className='slogan pt-5 text-center'>
              <span className='mb-0'>Forgot&nbsp;</span>
              <span className='mb-0'>Password</span>
            </div>
          </div>
          <div className='pt-3 row justify-content-center align-items-center'>
            <div className='col-12 col-sm-8 col-md-8 col-lg-7 col-xl-5'>
              <div className='pb-4 text-center'>
                <h6 className='pt-1'>
                  Please enter your e-mail address associated with your HCP™
                  account. We will send a reset password e-mail shortly.
                </h6>
              </div>
              <Form onSubmit={handleSubmit(forgotPass)}>
                <Form.Group controlId='formEmail' className='mb-4'>
                  {/* <Form.Control size="lg" className="input-rounded border"
                    type="email"
                    name="email"
                    placeholder="E-mail Address"
                    onChange={(e) => setEmail(e.target.value)}
                    ref={register({ required: true })}
                  /> */}
                  {/* {errors.email && (
                    <Form.Text className="small help-block text-danger">
                      Email is required
                    </Form.Text>
                  )} */}
                  <Form.Control
                    type='email'
                    size='lg'
                    className='input-rounded border'
                    placeholder='E-mail Address'
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {error && !email && (
                    <Form.Text className='help-block text-danger text-center'>
                      Email is required
                    </Form.Text>
                  )}
                  {error && email && (
                    <Form.Text className='help-block text-danger text-center'>
                      Please enter a valid email address
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group controlId='formButton'>
                  <div className='row'>
                    <div className='col-6'>
                      <button
                        type='button'
                        className='btn button-primary btn-rounded p-2 w-100 text-center'
                        onClick={goToLogin}
                      >
                        Return to Login
                      </button>
                    </div>
                    <div className='col-6'>
                      <button
                        disabled={loader}
                        type='submit'
                        className='btn button-secondary btn-rounded p-2 w-100 text-center'
                      >
                        {loader ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <Spinner
                              animation='border'
                              size='sm'
                              variant='light'
                              className='mr-2'
                            />
                            please wait...
                          </div>
                        ) : (
                          'Send E-mail'
                        )}
                      </button>
                    </div>
                  </div>
                </Form.Group>
              </Form>
            </div>
          </div>
          <div className='pt-3 row justify-content-center align-items-center'>
            <div className='col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5'>
              <Footer />
            </div>
          </div>
        </div>
      </div>

      <Notifications options={{ zIndex: 1031 }} />
    </div>
  );
}

export default ForgotPassword;